import { ActionPortalTypes } from "../../../types/actionPortal.type";
import { Languages } from "../../../enums/languages";

const actionBoxLang = {
    [ActionPortalTypes.ADD_FILE_TO_REQUEST]: {
        "card-title": {
            [Languages.Hebrew]: { default: "הוספת קובץ לבקשה" },
            [Languages.Arabic]: { default: "إضافة ملف إلى الطلب" },
            [Languages.English]: { default: "Add File To Request" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "הוספת קובץ לבקשה קיימת" },
            [Languages.Arabic]: { default: "إضافة ملف إلى طلب موجود" },
            [Languages.English]: { default: "Add a file to an existing request" }
        }
    },
    [ActionPortalTypes.CANCEL_PERMIT]: {
        "card-title": {
            [Languages.Hebrew]: { default: "ביטול תו קיים" },
            [Languages.Arabic]: { default: "إلغاء تصريح موجود" },
            [Languages.English]: { default: "Cancel Existing Permit" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "ביטול תו חניה קיים" },
            [Languages.Arabic]: { default: "إلغاء تصريح انتظار موجود" },
            [Languages.English]: { default: "Cancel an existing parking permit" }
        }
    },
    [ActionPortalTypes.CHECK_PEMIT_VALIDITY]: {
        "card-title": {
            [Languages.Hebrew]: { default: "בדיקת תוקף תו קיים" },
            [Languages.Arabic]: { default: "التحقق من صلاحية التصريح الحالي" },
            [Languages.English]: { default: "Check Existing Permit Validity" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "בדיקת תוקף של תו חניה קיים" },
            [Languages.Arabic]: { default: "التحقق من صلاحية تصريح انتظار موجود" },
            [Languages.English]: { default: "Check the validity of an existing parking permit" }
        }
    },
    [ActionPortalTypes.CHECK_REQUEST_STATUS]: {
        "card-title": {
            [Languages.Hebrew]: { default: "בדיקת סטטוס בקשה" },
            [Languages.Arabic]: { default: "التحقق من حالة الطلب" },
            [Languages.English]: { default: "Check Request Status" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "בדיקת סטטוס של בקשה קיימת" },
            [Languages.Arabic]: { default: "التحقق من حالة طلب موجود" },
            [Languages.English]: { default: "Check the status of an existing request" }
        }
    },
    [ActionPortalTypes.UPDATE_VEHICLE_DETAILS]: {
        "card-title": {
            [Languages.Hebrew]: { default: "החלפת רכב לתו" },
            [Languages.Arabic]: { default: "تغيير السيارة للتصريح" },
            [Languages.English]: { default: "Update Vehicle Details For Permit" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "החלפת פרטי רכב עבור תו חניה קיים" },
            [Languages.Arabic]: { default: "تغيير تفاصيل السيارة لتصريح انتظار موجود" },
            [Languages.English]: { default: "Update vehicle details for an existing parking permit" }
        }
    },
    [ActionPortalTypes.RENEWED_PERMIT_OPTION]: {
        "card-title": {
            [Languages.Hebrew]: { default: "חידוש תו חניה" },
            [Languages.Arabic]: { default: "تجديد تصريح الانتظار" },
            [Languages.English]: { default: "Renew Parking Permit" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "חידוש תו חניה קיים" },
            [Languages.Arabic]: { default: "تجديد تصريح انتظار موجود" },
            [Languages.English]: { default: "Renew an existing parking permit" }
        }
    },
    [ActionPortalTypes.ADD_PERMIT_REQUEST]: {
        "card-title": {
            [Languages.Hebrew]: { default: "הגשת בקשה לתו חניה" },
            [Languages.Arabic]: { default: "تقديم طلب تصريح انتظار" },
            [Languages.English]: { default: "Submit Parking Permit Request" }
        },
        "card-description": {
            [Languages.Hebrew]: { default: "הגשת בקשה חדשה לתו חניה" },
            [Languages.Arabic]: { default: "تقديم طلب جديد لتصريح انتظار" },
            [Languages.English]: { default: "Submit a new parking permit request" }
        }
    }
}

export default actionBoxLang;